import { ArchetypeName } from "../types/personality";

const basePath = "/personalities";

export function getArchetypeIcon(archetypeName: ArchetypeName) {
  switch (archetypeName) {
    case "jester":
      return `${basePath}/jester.svg`;
    case "ruler":
      return `${basePath}/ruler.svg`;
    case "creative":
      return `${basePath}/creative.svg`;
    case "lover":
      return `${basePath}/lover.svg`;
    case "magician":
      return `${basePath}/magician.svg`;
    case "rebel":
      return `${basePath}/rebel.svg`;
    case "explorer":
      return `${basePath}/explorer.svg`;
    case "sage":
      return `${basePath}/sage.svg`;
    case "neighbor":
      return `${basePath}/neighbor.svg`;
    case "caregiver":
      return `${basePath}/caregiver.svg`;
    case "hero":
      return `${basePath}/hero.svg`;
    case "innocent":
      return `${basePath}/innocent.svg`;
  }
}

export function translateArchetypeName(name?: string): ArchetypeName | null {
  switch (name) {
    case "Jester":
      return "jester";
    case "Ruler":
      return "ruler";
    case "Creative":
    case "Creator":
      return "creative";
    case "Lover":
      return "lover";
    case "Magician":
      return "magician";
    case "Rebel":
      return "rebel";
    case "Explorer":
      return "explorer";
    case "Sage":
      return "sage";
    case "Neighbor":
      return "neighbor";
    case "Caregiver":
      return "caregiver";
    case "Hero":
      return "hero";
    case "Innocent":
      return "innocent";
  }

  return null;
}
